import React, { useState, useEffect } from "react";
import { useField, useFormikContext } from "formik";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  TextField,
} from "@mui/material";
import { getBranchBanks } from "../../../http/api/BankAPI"; // Replace with your actual import
const ITEM_HEIGHT = 36;
const MAX_ITEMS = 10;
const BankBranchSelect = ({ name, ...props }) => {
  const [listBankBranches, setListBankBranches] = useState([]);
  const { values, setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  useEffect(() => {
    if (values.bankCd) {
      fetchBankBranches(values.bankCd);
    } else {
      setListBankBranches([]); // Reset branches if bankCd is null
    }
  }, [values.bankCd]);

  async function fetchBankBranches(bankCd) {
    try {
      const response = await getBranchBanks({ bankCd });
      setListBankBranches(response.data ?? response);
    } catch (error) {
      console.error(`Failed to fetch branches for bank code ${bankCd}:`, error);
    }
  }

  const handleChange = (event) => {
    helpers.setValue(event.target.value);
    if (props.onChange) {
      props.onChange(event);
    }
    props.moveNext();
  };

  return (
    <FormControl {...props} error={meta.touched && Boolean(meta.error)}>
      <InputLabel id={`${name}-label`} shrink>
        {props.label}
      </InputLabel>
      <Select
        labelId={`${name}-label`}
        id={name}
        {...field}
        onChange={handleChange}
        label={props.label}
        value={field.value === null ? -1 : field.value}
        inputRef={props.inputRef}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: ITEM_HEIGHT * MAX_ITEMS,
              overflowY: "auto", // Enables scrolling
            },
          },
        }}
      >
        <MenuItem value={-1}>未選択</MenuItem>
        {listBankBranches.map((branch) => (
          <MenuItem key={branch.bankBranchCd} value={branch.bankBranchCd}>
            {branch.bankBranchName}
          </MenuItem>
        ))}
      </Select>
      {meta.touched && meta.error && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  );
};

export default BankBranchSelect;
